import { Chip, Drawer } from '@material-ui/core';
import * as React from 'react';
import { AppliedFilterBarOpt, FilterGroup, IFilterBar } from '../../models/utilities/filter-bar';
import { Button } from '../button/Button';
import './FilterBar.scss';
import { FilterBarGroup } from './FilterBarGroup';
import { FilterBarGroupExpanded } from './FilterBarGroupExpanded';

export class FilterBarOpt {

    public id: string = '';
    public label: string = '';
    public checked: boolean = false;

    constructor(id: string, label: string) {
        this.id = id;
        this.label = label;
    }

}

interface IProps {
    filterProps: IFilterBar;
    // TODO: figure out what a filter callback signature should be and add it to method types
    onApplyFilters: any;
    // TODO: figure out what a filter callback signature should be and add it to method types
    onUpdateFilters : any;
    // TODO: figure out what a filter callback signature should be and add it to method types
    onFilterDelete: any;
    // TODO: figure out what a filter callback signature should be and add it to method types
    onFilterReset: any;
}

export const FilterBar = (props: IProps) => {
    
    const [isMoreOpen, setIsMoreOpen] = React.useState(false);
    const NUMBER_OF_FILTERS_TO_SHOW = 5;

    // React.useEffect(() => {
    //     const listener = (event:any) => {
    //       if (event.code === "Enter" || event.code === "NumpadEnter") {
    //         console.log("Enter key was pressed. Run your function.");
    //         // callMyFunction();
    //       }
    //     };
    //     document.addEventListener("keydown", listener);
    //     return () => {
    //       document.removeEventListener("keydown", listener);
    //     };
    //   }, []);
    
    /**
     * Capture the form submit and just swallow it.
     * @param e The form submit event
     */
    const onSubmitCapture = (e: any) => {
        e.preventDefault();
    };

    const toggleMoreFilters = () => {
        setIsMoreOpen(!isMoreOpen);
    };

    const closeMoreFilters = () => {
        setIsMoreOpen(false);
    };

    const closeAndApply = () => {        
        setTimeout(() => {
            setIsMoreOpen(false);
            props.onApplyFilters();
        }, 200);        
    };

    return <React.Fragment>
            <form onSubmit={ props.onApplyFilters } onSubmitCapture={ onSubmitCapture } autoComplete="off">
                <div className="row no-gutters filter-bar">           
                    {
                        props.filterProps.filters
                            .slice(0, NUMBER_OF_FILTERS_TO_SHOW)
                            .map((filter : FilterGroup, idx : number) => 
                                <FilterBarGroup 
                                    key={ filter.uuid }
                                    onModelChange={ props.onUpdateFilters }
                                    onApplyFilter={ props.onApplyFilters }
                                    filterModel={ filter } />
                            )                
                    }
                    {
                        props.filterProps.filters.length > NUMBER_OF_FILTERS_TO_SHOW
                            ? <div className="col filter-bar-action">
                                <button
                                    id="clear-button"
                                    onClick={ toggleMoreFilters }
                                    type="button"
                                    className="btn-flat">
                                        More +
                                </button>
                            </div>
                            : null                        
                    }
                    <div className="col filter-bar-action">
                        <button
                            id="search-button"
                            onClick={ () => props.onApplyFilters() }
                            type="button"
                            className="btn action">
                                Apply
                            <i className="la la-filter" />
                        </button>
                        <button 
                            id="reset-button"
                            type="button"
                            onClick={ () => props.onFilterReset() }
                            className="reset">
                            Reset
                        </button>
                    </div>
                </div>
                {
                    props.filterProps.appliedFilters.length > 0
                        ? <div className="row">
                            <div className="col-12 applied-filters">
                                <span className="filter-title-text">Active Filters: </span>
                                {
                                    props.filterProps.appliedFilters.length > 0 
                                        ? props.filterProps.appliedFilters.map((itm: AppliedFilterBarOpt) => 
                                            <Chip
                                                key={ `chip-${itm.uuid}` }
                                                label={ itm.label }
                                                onDelete={ () => { props.onFilterDelete(itm.uuid); } }
                                                className="applied-filter-chip"
                                            />
                                        ) 
                                        : null
                                }
                            </div>
                        </div> 
                        : null
                }            
            </form>
            <Drawer 
                anchor="right" 
                open={ isMoreOpen } 
                onClose={ closeMoreFilters  }>
                    <div className="more-filter-drawer">
                        <h3>All Filters</h3>
                        {
                            props.filterProps.filters.map((filter : FilterGroup) => 
                                <FilterBarGroupExpanded 
                                    key={ filter.uuid }
                                    onModelChange={ props.onUpdateFilters }
                                    onApplyFilter={ closeAndApply }
                                    filterModel={ filter } />
                                )                
                        }
                        <div className="col">
                            <Button
                                text="Apply"
                                id="search-button"
                                testID="filter-bar-search-button"
                                onBtnClick={ closeAndApply }
                                icon="la-filter"
                                classes="attention" />
                        </div>
                    </div>
            </Drawer>
        </React.Fragment>;

};
